import type { Caducidad } from "../logica";

/** Qué dejó viejo una versión nueva y qué rehacer, por orden. El Plan lo enseña igual. */
export default function AvisoCaduca({ c }: { c: Caducidad }) {
  return (
    <div className="aviso">
      <p style={{ margin: "0 0 6px" }}><b>La versión {c.version} cambia algo que ya tenías hecho:</b> {c.que}</p>
      <p style={{ margin: "0 0 4px" }}>Para que todo vuelva a casar, por este orden:</p>
      <ol style={{ margin: "0 0 0 18px", padding: 0 }}>
        {c.pasos.map((p) => <li key={p}>{p}</li>)}
      </ol>
    </div>
  );
}
